
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';

import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';

import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { Dialog, DialogModule } from 'primeng/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetail } from 'src/app/components/registration/bank-details/bankDetails';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-vendor-app-approved',
  templateUrl: './vendor-app-approved.component.html',
  styleUrls: ['./vendor-app-approved.component.scss']
})
export class VendorAppApprovedComponent implements OnInit {

  @ViewChild('appVerificationTable', { static: true })
  public appVerificationTable: Table;
  @ViewChild('estVerificationTable', { static: true })
  public estVerificationTable: Table;

  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  items: MenuItem[];

  statuses: any[];
  appVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  appVerificationModel: DepartmentAppVerificationModel[];

  displayEstimateDialog: boolean = false;

  public category: any;
  public selectedCategory: any = [];
  public component: any;
  public selectedComponent: any = [];
  public sizePrice: any;
  public selectedSizePrice: any = [];

  public vendorRegId: any;
  public programId: any;
  public programmeName: any;
  public programmeAppId: any;
  public programmeFarmerName: any;
  public appId: any;
  public userId: any;
  public vendorAssociateID: any;

  public categoryId: any;
  public componentId: any;
  public sizeId: any;

  public tableHide: boolean = false;

  public tableData: any = [];

  uploadedFiles: any[] = [];

  public transCharge: any;
  public plantSpacing: any;
  public rowSpacing: any;

  public estimatedComponentTotal: any;
  public estimatedGSTTotal: any;
  public estimatedGrandTotal: any;

  finalEstimationDetails: FormGroup;
  public enteredQuantity: number = 1;
  filteredCropType: any[];
  filteredCrop: any[];

  public added: boolean = false;
  public reqBody: any;
  public isUpdateClicked: boolean = false;

  public isTransportFree: boolean = false;

  public cropType: any = [];
  public crop: any = [];
  // crop: any = [
  //   {
  //     cropName: 'Wheat',
  //     cropId: 0,
  //   },
  //   {
  //     cropName: 'Rice',
  //     cropId: 1,
  //   },
  //   {
  //     cropName: 'Barley',
  //     cropId: 2,
  //   },
  // ];

  public showProDataCalError: boolean = false;
  public isProDataCalculated: boolean = false;
  public showInputfields: boolean = true;
  public proCalculatedData: any;

  public grandTotal: any
  public totalarea: any;
  public MIAreaCustomerror: any
  
  ipAddress: any = '000.000.000';

  public maxSubsidy: number;
  
  tableDataForReqBody: any;
  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService,
    private vendorService: VendorDashboardService,
    private router: Router,
    private tokenService: TokenService,
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private confirmationService: ConfirmationService,
    private ipService: IpAddressService,
    private cryptoJsService: CryptoJsService,
    private translateService: TranslateService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    
  ) { }

  ngOnInit() {
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.getIP();

    this.getCropMaster();
    // this.appVerificationTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'equals', operator: 'and' },
    // ];
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_MI_Estimation_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_MI_Estimation_List");
        }
      },
    ];
    // this.items = [
    //   {
    //     label: 'Download excel',
    //     icon: 'pi pi-fw pi-download',
    //     command: () => {
    //       this.exportExcel();
    //     },
    //   },
    //   {
    //     label: 'Download Pdf',
    //     icon: 'pi pi-fw pi-download',
    //     command: () => {
    //       this.downloadSheetAsPdf();
    //     },
    //   },
    // ];

    this.finalEstimationDetails = this._fb.group({
      // transOtherCharges: ['', Validators.required],
      plantSpacing: ['', Validators.required],
      rowSpacing: ['', Validators.required],
      latitude: [''],
      longitude: [''],
      remarks: ['', Validators.required],
      cropType: ['', Validators.required],
      crop: ['', Validators.required],
      discountRate: [''],
      landMapPath: ['', Validators.required],
      signaturePath: ['', Validators.required],
      // taxRate: ['', Validators.required],
      MIArea: ['', Validators.required],
    });
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        this.appVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }
  refreshTable() {
    
    this.loadData();
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    // console.log('token1', token);
    let payload = atob(token?.authToken?.split('.')[1]);
    // console.log('payload1', JSON.parse(payload));
    this.userId = JSON.parse(payload)?.sub;
    // const token: any = this.tokenService.retrieve();
    // console.log('token', token)
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);
    // console.log('payload', JSON.parse(payload))

    // this.loader.start();
    this.loading = true;
    let sub = this.vendorService
      .GetVendorDashboard(JSON.parse(payload)?.sub, "Approved", this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'MI Estimation Details', '', new Date(), 'Success');

          // console.log('Response Data', data);
          this.userId = JSON.parse(payload)?.sub;
          if (data.length > 0) {
            this.appVerificationModel = data;
          }
          else{
            this.appVerificationModel = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'MI Estimation Details', '', new Date(), err);

          if(err == 'Data not Found!'){
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: err,
            });
          }else{
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        },
      });

      this.subscriptions.push(sub);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'APP ID' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'village', header: 'Village' },
      { field: 'block', header: 'Block' },
      { field: 'district', header: 'District' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Status_Ar', header: 'Current Status' },
      { field: 'status', header: 'Status' },
      { field: 'DeptRemarks', header: 'Dept Remarks' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.appVerificationModel);
        doc.save('Applications_Details.pdf');
      });
    });
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  printForm(appId,statusCode,programId) {
    // console.log(appId,statusCode)
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      
      // this.router.navigate(['vendor', 'print', appId,this.vendorRegId,programId],{ queryParams: { statusCode: statusCodeEncrypted}});
      // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
      this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
              
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App ID":d.appID,
          "Farmer Name":d.FarmerName,
          "Village":d.village,
          "Block":d.block,
          "District":d.district,
          "Age Of Application":d.AgeOfApplication,
          "Programme Name":d.ProgrammeName,
          "Land Detail":d.LandDetail,
          "Total Area":d.Total_Area,
          "Pending Completed Days":d.PendingCompletedDays,
          "Current Status":d.Status_Ar,
          "Status":d.status,
          "Dept Remarks":d.DeptRemarks,  
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
    // import('xlsx').then((xlsx) => {
    //   let dataToSave = this.appVerificationModel.map((d: any) => {
    //     return {
    //       'APP ID': d.appID,
    //      FarmerName: d.farmerName,
    //      //"Farmer Name": d.farmerName,
    //       Village: d.village,
    //       Block: d.block,
    //       District: d.district,
    //       'Age Of Application': d.AgeOfApplication,
    //       'Programme Name': d.ProgrammeName,
    //       'Land Detail': d.LandDetail,
    //       'Total Area': d.Total_Area,
    //       Status: d.status,
    //       'Dept Remarks': d.DeptRemarks,
    //     };
    //   });
    //   const worksheet = xlsx.utils.json_to_sheet(dataToSave);
    //   const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    //   const excelBuffer: any = xlsx.write(workbook, {
    //     bookType: 'xlsx',
    //     type: 'array',
    //   });
    //   this.saveAsExcelFile(excelBuffer, 'Applications List');
    // });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  addEstimation(product) {
    // this.solarApplicatonForm.patchValue({
    //   solarId: solarMasteredFilteredData.Solar_ID,
    // });
    this.programmeName = product.ProgrammeName;
    this.programmeAppId = product.appID;
    this.programmeFarmerName = product.FarmerName;

    // CropIDEst, CropTypeIDEst, CropNameEst, CropTypeNameEst

    if (product.ProgrammeName == 'Portable Sprinkler') {
      this.isTransportFree = true;
    }

    // console.log(product, 'selected rowData');
    this.appId = product.appID;

    this.totalarea = product.Total_Area;
    this.finalEstimationDetails.get('MIArea').setValue(product.Total_Area);
    // console.log(this.appId, 'App ID from addEstimation()');

    this.programId = product.ProgramID;
    // this.getCropMaster();
    this.getCategoryDropdown();

    let reqBody = {
      AppId: product.appID,
      VendorRegId: this.vendorRegId,
      ProgramId: product.ProgramID,
    };

    this.showInputfields = true;

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getVendorMIEstimation(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // console.log('Get Vendor Estimation Detailss', data);
          this.displayEstimateDialog = true;

          if(data.CropTypeIDEst && data.CropIDEst && data.PlantSpacingPreEst && data.RowSpacingPreEst){
            this.showInputfields = false;
          }

          let label: any;
          let label2: any;
          this.cropType.forEach((res) => {
            if (res.data === data.CropTypeIDEst) {
              label = res;
              this.crop = label.children;
              this.crop.forEach((res2) => {
                if(res2.data === data.CropIDEst){
                  label2 = res2;
                }
              })
              return;
            }
          });

          // this.appId = data.AppID;
          // this.programId = data.ProgID;
          this.vendorAssociateID = data.VandorAssociateID;
          // this.getCategoryDropdown();
          // this.tableData = [];
          // this.tableData = data.EstimationComponentDetail.map((row) => ({
          //   ...row,
          //   Amount: row.Price * row.Quantity,
          //   GSTAmount: (row.Price * row.Quantity * row.GST) / 100,
          //   AmountWithGST:
          //     row.Price * row.Quantity +
          //     (row.Price * row.Quantity * row.GST) / 100,
          // }));
          // this.calculatePrice();
          // console.log('table dataaaaa', this.tableData);

          this.finalEstimationDetails.patchValue({
            plantSpacing: data.PlantSpacingPreEst,
            rowSpacing: data.RowSpacingPreEst,
            cropType: label,
            crop: label2,
          });
          // this.onMIAreaChange()
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! MI Estimation not loaded.',
          });
        },
      });

    this.displayEstimateDialog = true;
  }

  getCategoryDropdown() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
    };
    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getCategory(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.category = res.$values;
          // this.loader.close();
          this.loading = false;
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.category = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category not loaded.',
          });
        },
      });
  }

  getComponentDropdown() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
      CategoryId: this.categoryId,
    };

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getComponent(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.component = res.$values;
          // this.loader.close();
          this.loading = false;
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Component not loaded.',
          });
        },
      });
  }

  getSizeAndPriceDropdown() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
      CategoryId: this.categoryId,
      ComponentId: this.componentId,
    };

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getSizeAndPrice(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sizePrice = res.$values;
          // this.loader.close();
          this.loading = false;
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Size And Price not loaded.',
          });
        },
      });
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          // console.log('Crop Master', res);
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  onSelectCategory() {
    this.tableHide = false;
    this.component = null;
    this.componentId = null;
    this.selectedComponent = [];
    this.sizePrice = null;
    this.sizeId = null;
    this.selectedSizePrice = [];
    this.categoryId = this.selectedCategory?.categoryId;
    this.getComponentDropdown();
  }

  onSelectComponent() {
    this.tableHide = false;
    this.sizeId = null;
    this.sizePrice = null;
    this.selectedSizePrice = [];
    this.componentId = this.selectedComponent?.componentId;
    this.getSizeAndPriceDropdown();
  }

  onSelectSizePrice() {
    this.sizeId = this.selectedSizePrice?.sizeId;
    this.tableHide = true;
  }

  addTable() {
    this.tableData.push({
      CatID: this.selectedCategory.categoryId,
      CatName: this.selectedCategory.categoryName,
      ComponentID: this.selectedComponent.componentId,
      ComponentName: this.selectedComponent.componentName,
      SizeID: this.selectedSizePrice.sizeId,
      autoIdPriceTable: this.selectedSizePrice.autoIdPriceTable,
      Size: this.selectedSizePrice.sizeAndPrice.split('and')[0],
      Price: this.selectedSizePrice.sizeAndPrice.split('and')[1].split(' ')[2],
      Quantity: this.enteredQuantity,
      Amount:
        parseFloat(
          this.selectedSizePrice.sizeAndPrice.split('and')[1].split(' ')[2]
        ) * this.enteredQuantity,
      GST: this.selectedSizePrice.gstPercent,
      GSTAmount:
        ((parseFloat(
          this.selectedSizePrice.sizeAndPrice.split('and')[1].split(' ')[2]
        ) *
          this.enteredQuantity) /
          100) *
        this.selectedSizePrice.gstPercent,
      AmountWithGST:
        parseFloat(
          this.selectedSizePrice.sizeAndPrice.split('and')[1].split(' ')[2]
        ) *
        this.enteredQuantity +
        ((parseFloat(
          this.selectedSizePrice.sizeAndPrice.split('and')[1].split(' ')[2]
        ) *
          this.enteredQuantity) /
          100) *
        this.selectedSizePrice.gstPercent,
    });
    // console.log('tableData', this.tableData);

    // this.selectedCategory = [];
    // this.selectedComponent = [];
    // this.selectedSizePrice = [];
    // this.component = [];
    // this.sizePrice = [];
    // this.enteredQuantity = 1;
    this.tableHide = false;
    this.calculatePrice();
  }

  calculatePrice() {
    this.estimatedComponentTotal = 0;
    this.estimatedGSTTotal = 0;
    this.estimatedGrandTotal = 0;
    this.tableData.forEach((element) => {
      this.estimatedComponentTotal =
        this.estimatedComponentTotal + element.Amount;

      this.estimatedGSTTotal = this.estimatedGSTTotal + element.GSTAmount;
      // this.estimatedGrandTotal =
      //   this.estimatedGrandTotal + element.AmountWithGST;
    });
    this.onMIAreaChange()

  }
  onMIAreaChange() {
    this.grandTotal = 0
    let MiArea = this.finalEstimationDetails.value.MIArea ? this.finalEstimationDetails.value.MIArea : 0
    if (Number(this.totalarea) < MiArea) {
      this.MIAreaCustomerror = true
      this.finalEstimationControls.MIArea.setErrors({error:'MI Area should not be greater than farmer area'})
    } else {
      this.MIAreaCustomerror = false
    }
    let transPortArea = this.isTransportFree ? 0 : (2500 * MiArea)
    let discount = this.finalEstimationDetails.value.discountRate ? this.finalEstimationDetails.value.discountRate : 0;
    let componentTotal = discount ? this.estimatedComponentTotal - ((this.estimatedComponentTotal * discount) / 100) : this.estimatedComponentTotal;
    this.grandTotal = componentTotal + transPortArea
    this.estimatedGSTTotal = (componentTotal * 12) / 100
  }

  onRowDelete(rowIndex) {
    // console.log(this.tableData, 'beforeData');
    this.tableData = this.tableData.filter((q, i) => rowIndex != i);
    // console.log(this.tableData, 'updatedTableDtata');
    this.calculatePrice();
  }

  submitFinalEstimation() {
    let value = this.finalEstimationDetails.value;

    this.tableDataForReqBody = this.tableData;

    const tableDataToPush: any = [];
    this.tableData.forEach((row) => {
      tableDataToPush.push({
        catID: row.CatID,
        componentID: row.ComponentID,
        sizeID: row.SizeID,
        quantity: row.Quantity,
        autoIdPriceTable : row.autoIdPriceTable
      });
    });

    let transportOtherExpensesToSubmit: any;

    if (this.isTransportFree) {
      transportOtherExpensesToSubmit = 0;
    } else {
      transportOtherExpensesToSubmit = 2500 * value.MIArea;
    }

    let discountRate: number;
    if (value.discountRate == '' || value.discountRate == null) {
      discountRate = 0;
    } else {
      discountRate = value.discountRate;
    }
    let componentAmount =
      this.estimatedComponentTotal -
      (this.estimatedComponentTotal * discountRate) / 100;

    let finalData = {
      appID: this.appId,
      vendorRegId: this.vendorRegId,
      progID: this.programId,
      proData_MaxSubsidy:this.proCalculatedData.maxSubsidy,
      // componentAmount: this.estimatedComponentTotal - this.estimatedComponentTotal*value.discountPercent/100,
      componentAmount: componentAmount,
      //hardcoded
      // vendorAssociateID: this.vendorRegId,
      vendorAssociateID: this.vendorRegId,
      transportOtherExpenses: transportOtherExpensesToSubmit,
      taxRate: this.estimatedGSTTotal,
      discountRate: discountRate,
      miArea: value.MIArea,
      landMapPath: value.landMapPath,
      signaturePath: value.SignaturePath,
      // lat: value.latitude,
      // long: value.longitude,
      plantSpacing: value.plantSpacing,
      rowSpacing: value.rowSpacing,
      cropTypeId: value.cropType.data,
      cropID: value.crop.data,
      remarks: value.remarks,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,

      estimationComponentDetail: tableDataToPush,
    };

    // console.log([finalData], 'PostData');

    this.reqBody = [finalData];
    this.postVendorEstimationDetail(this.reqBody);
    this.tableData = [];
    this.finalEstimationDetails.reset();
    this.displayEstimateDialog = false;
    this.isTransportFree = false;
    this.isProDataCalculated = false;
  }

  get finalEstimationControls() {
    return this.finalEstimationDetails.controls;
  }

  filterCropType(event: any) {
    // console.log(event);
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.cropType.length; i++) {
      const crop = this.cropType[i];
      if (crop.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(crop);
      }
    }

    this.filteredCropType = filtered;
    if(this.filteredCropType.length == 1){
      this.onSelectCropType(this.filteredCropType);
    }
  }

  filterCrop(event: any){
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.crop.length; i++) {
      const crop = this.crop[i];
      if (crop.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(crop);
      }
    }

    this.filteredCrop = filtered;
    // console.log(this.filteredCrop, 'FilteredCrop');
  }

  onSelectCropType(event){
    this.crop = event[0].children;
    this.finalEstimationControls.crop.reset();
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer
      .uploadFile(data, this.userId, formcontrol)
      .subscribe((resp: any) => {
        // this.loader.close();
        this.loading = false;
        // console.log(resp);
        if (resp.statusCode == 200) {
          this.finalEstimationDetails.patchValue({ [formcontrol]: resp.data });
          // console.log(this.finalEstimationDetails);
          // this.onLandMapUpload();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
    uploadElement.clear();
  }

  postVendorEstimationDetail(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .postVendorMIEstimationDetail(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // console.log(reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})), this.tableDataForReqBody, "helllooooo")
          // this.activityRecordService.activityRecord(this.userId, 'Create Vendor Estimation', this.programmeAppId, new Date(), data, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          if(data == "S:Successfully Submitted"){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: data,
            });
          }
          // console.log('VendorEstimationAddedSuccessfull', data);
          else{
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data,
            });
          }
          this.loadData();
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Create Vendor Estimation', this.programmeAppId, new Date(), err, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! Estimation Not Added',
          });
        },
        complete: () => {
          this.tableDataForReqBody = null;
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail: 'Estimation Added Successfully',
          // });
        },
      });
  }

  cancelFinalEstimation() {
    this.tableData = [];
    this.finalEstimationDetails.reset();
    this.displayEstimateDialog = false;
  }

  onCloseDialog() {
    this.isTransportFree = false;
    this.tableData = [];
    this.finalEstimationDetails.reset();
    this.isUpdateClicked = false;
    this.isProDataCalculated = false;
    this.selectedCategory = [];
    this.selectedComponent = [];
    this.selectedSizePrice = [];
    this.enteredQuantity = 1;
  }

  deleteEstimation(product) {
    let reqBody = {
      AppId: product.appID,
      VendorRegId: product.Vendor_Code,
      ProgramId: product.ProgramID,
    };
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // this.loader.start();
    this.loading = true;
        this.vendorService
          .deleteEstimation(reqBody)
          .pipe(first())
          .subscribe({
            next: (data) => {
              // this.loader.close();
          this.loading = false;
              // console.log('Vendor Estimation Deleted Success', data);
              this.messageService.add({
                severity: 'info',
                summary: 'Status',
                detail: data,
              });
            },
            error: () => {
              // this.loader.close();
          this.loading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data Error! Estimation Not Deleted',
              });
            },
            // complete: () => {
            //   this.messageService.add({
            //     severity: 'success',
            //     summary: 'Success',
            //     detail: 'Estimation Deleted Successfully',
            //   });
            // },
          });
        this.loadData();
      },
    });
  }

  updateEstimation(product) {
    this.programmeName = product.ProgrammeName;
    this.programmeAppId = product.appID;
    this.programmeFarmerName = product.FarmerName;
    this.totalarea = product.Total_Area;

    if (product.ProgrammeName == 'Portable Sprinkler') {
      this.isTransportFree = true;
    }

    // this.getCropMaster();
    this.isUpdateClicked = true;
    // console.log('vendddoooooor', this.vendorRegId);
    let reqBody = {
      AppId: product.appID,
      // VendorRegId: product.Vendor_Code,
      VendorRegId: this.vendorRegId,
      ProgramId: product.ProgramID,
    };

    this.showInputfields = true;
    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getVendorMIEstimation(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // console.log('Get Vendor Estimation Detailss', data);
          
          if(data.CropTypeIDEst && data.CropIDEst && data.PlantSpacingPreEst && data.RowSpacingPreEst){
            this.showInputfields = false;
          }
          
          this.displayEstimateDialog = true;
          
          let label: any;
          let label2: any;
          this.cropType.forEach((res) => {
            if (res.data === data.CropTypeIDEst) {
              label = res;
              this.crop = label.children;
              this.crop.forEach((res2) => {
                if(res2.data === data.CropIDEst){
                  label2 = res2;
                }
              })
              return;
            }
          });

          this.appId = data.AppID;
          // this.vendorRegId = data.VendorRegId;
          this.programId = data.ProgID;
          this.vendorAssociateID = data.VandorAssociateID;
          this.getCategoryDropdown();
          // this.tableData = [];
          this.tableData = data.EstimationComponentDetail.map((row) => ({
            ...row,
            Amount: row.Price * row.Quantity,
            GSTAmount: (row.Price * row.Quantity * row.GST) / 100,
            AmountWithGST:
              row.Price * row.Quantity +
              (row.Price * row.Quantity * row.GST) / 100,
          }));
          this.calculatePrice();
          // console.log('table dataaaaa', this.tableData);

          this.finalEstimationDetails.patchValue({
            // transOtherCharges: data.TransportOtherExpenses,
            plantSpacing: data.PlantSpacing,
            rowSpacing: data.RowSpacing,
            // latitude: data.Lat,
            // longitude: data.Long,
            remarks: data.Remarks,
            cropType: label,
            crop: label2,
            discountRate: data.DiscountRate,
            landMapPath: data.LandMapPath,
            signaturePath: data.signaturePath,
            // taxRate: data.TaxRate,
            MIArea: data.MIArea,
          });
          this.onMIAreaChange()
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! MI Estimation not loaded.',
          });
        },
      });
  }

  submitFinalEstimationUpdated() {
    let value = this.finalEstimationDetails.value;

    this.tableDataForReqBody = this.tableData;
    
    const tableDataToPush: any = [];
    this.tableData.forEach((row) => {
      tableDataToPush.push({
        catID: row.CatID,
        componentID: row.ComponentID,
        SizeID: row.SizeID,
        quantity: row.Quantity,
        autoIdPriceTable : row.autoIdPriceTable ? row.autoIdPriceTable : row.AutoIdPriceTable
      });
    });

    let transportOtherExpensesToSubmit: any;

    if (this.isTransportFree) {
      transportOtherExpensesToSubmit = 0;
    } else {
      transportOtherExpensesToSubmit = 2500 * value.MIArea;
    }

    let discountRate: number;
    if (value.discountRate == '' || value.discountRate == null) {
      discountRate = 0;
    } else {
      discountRate = value.discountRate;
    }
    let componentAmount =
      this.estimatedComponentTotal -
      (this.estimatedComponentTotal * discountRate) / 100;

    // console.log('tableDatatoUpdate', tableDataToPush);
    let finalData = {
      appID: this.appId,
      vendorRegId: this.vendorRegId,
      progID: this.programId,
      // componentAmount: this.estimatedComponentTotal - this.estimatedComponentTotal*value.discountPercent/100,
      componentAmount: componentAmount,
      //hardcoded
      // vendorAssociateID: JSON.stringify(this.vendorRegId),
      vendorAssociateID: this.vendorRegId,
      transportOtherExpenses: transportOtherExpensesToSubmit,
      taxRate: this.estimatedGSTTotal,
      discountRate: discountRate,
      miArea: value.MIArea,
      landMapPath: value.landMapPath,
      signaturePath: value.signaturePath,
      // lat: value.latitude,
      // long: value.longitude,
      plantSpacing: value.plantSpacing,
      rowSpacing: value.rowSpacing,
      cropTypeId: value.cropType.data,
      cropID: value.crop.data,
      remarks: value.remarks,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      estimationComponentDetail: tableDataToPush,
    };

    // console.log([finalData], 'PostData');

    this.reqBody = [finalData];
    this.updateVendorEstimationDetail(this.reqBody);
    this.tableData = [];
    this.finalEstimationDetails.reset();
    this.displayEstimateDialog = false;
    this.isTransportFree = false;
    this.isProDataCalculated = false;
  }

  updateVendorEstimationDetail(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .updateVendorEstimationDetail(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log(reqBody, this.tableDataForReqBody, "helllooooo")
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Update Vendor Estimation', this.programmeAppId, new Date(), data, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          if(data == "S:Successfully Updated"){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: data,
            });
          }
          else{
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data,
            });
          }
          // console.log('VendorEstimationUpdatedSuccessfull', data);
          
          this.loadData();
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Update Vendor Estimation', this.programmeAppId, new Date(), err, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! Estimation Not Updated',
          });
        },
        complete: () => {
          this.tableDataForReqBody = null;
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail: 'Estimation Updated Successfully',
          // });
        },
      });
    // this.loadData();
    this.isUpdateClicked = false;
  }

  getMaxSubsidy(reqBody) {
    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getMaxSubsidyEstimate(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // console.log('getMaxSubsidy', data);
          this.proCalculatedData = data;
          this.isProDataCalculated = true;
          // this.messageService.add({
          //   severity: 'info',
          //   summary: 'Status',
          //   detail: data,
          // });
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Updated Successfully',
        //   });
        // },
      });
  }
  proDataCalculation() {
    const tableDataToPush: any = [];
    this.tableData.forEach((row) => {
      tableDataToPush.push({
        cat:
          typeof row.CatID == 'string' ? row.CatID : JSON.stringify(row.CatID),
        component: row.ComponentName,
        size: row.Size,
        quantity: row.Quantity,
        price:
          typeof row.Price == 'string' ? row.Price : JSON.stringify(row.Price),
      });
    });

    if (
      !(
        this.finalEstimationControls?.rowSpacing?.errors?.required ||
        this.finalEstimationControls?.plantSpacing?.errors?.required ||
        this.finalEstimationControls?.MIArea?.errors?.required
      )
    ) {
      this.showProDataCalError = false;
      let finalDataToPost = {
        estimationComponentDetail: tableDataToPush,
        programId: this.programId,
        applicationId: this.appId,
        vendorId: this.vendorRegId,
        rowSpacing: this.finalEstimationDetails.value.rowSpacing,
        plantSpacing: this.finalEstimationDetails.value.plantSpacing,
        area: this.finalEstimationDetails.value.MIArea,
        //maxSubsidy:this.ProData_MaxSubsidy,
       // ProData_MaxSubsidy:this.proCalculatedData?.maxSubsidy,
       //ProData_MaxSubsidy:this.proCalculatedData?.ProData_MaxSubsidy,
    
      };
      let reqBody = finalDataToPost;

      // console.log('final Data to post', reqBody);
      this.getMaxSubsidy(reqBody);
    } else {
      this.showProDataCalError = true;
    }
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  rowBackgroundColor(product){
    if(product.Status_Ar == 'P'){
      if(product.PendingCompletedDays <= -2){
        return '#ff8080';
      }
      else if(product.PendingCompletedDays == -1){
        return '#ffc966';
      }
    }
    else if(product.Status_Ar == 'C' || product.Status_Ar == 'A'){
      if(product.PendingCompletedDays >= -1){
        return '#99e699';
      }
      else if(product.PendingCompletedDays <= -2){
        return '#ffb3b3';
      }
    }
    else
      return '#ffffff';
  }

  
  getCropTypeName(event) {
    this.finalEstimationDetails.controls['crop'].reset();
    this.crop = [];
    // console.log('event', event, this.cropType)
    const data = this.cropType.find(element => element?.data == event?.data)
    if (data) {
      this.crop = data.children
    } else {
      this.crop = []
    }
  }

}
